export default "<ion-app>\n  <!-- <ion-app [class.dark-theme]=\"dark\"> -->\n  <ion-router-outlet></ion-router-outlet>\n</ion-app>\n"